import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";
import { $enum } from "ts-enum-util";
import _ from "lodash";

import {
  ISupportTicket,
  Origin
} from "src/modules/support/api/support.api";
import SupportTicketOriginStyled from "src/modules/support/components/SupportTicketOrigin";

export const supportTicketOriginColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: accessor,
    size: 20,
    header: "Origin",
    enableSorting: false,
    minSize: 160,
    enableColumnFilter: true,
    cell: info => {
      const ticket = info.row.original as ISupportTicket;

      return (
        <SupportTicketOriginStyled
          origin={ticket.origin ? ticket.origin : Origin.Customer}
        />
      );
    },
    meta: {
      filter: {
        filterType: "select",
        options: $enum(Origin).getValues().map(origin => {
          return ({
            text: _.capitalize(origin),
            value: origin
          });
        })
      }
    }
  } as DisplayColumnDef<TData>);
};